import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, cta, launchOffer, offerItems, productImages } from '../data/content';
export function OfferStack() {
  return <section id="oferta" className="scroll-mt-4 bg-night" data-id="element-137" data-mp="2pu3qfbs9u3uy">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-138" data-mp="2kw24mj3gnqfs">
        <h2 className="text-center font-display text-[1.875rem] font-semibold uppercase leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-139" data-mp="2ktz61ao8sozg">
          Todo lo que recibes hoy
        </h2>

        <div className="mx-auto mt-10 grid max-w-5xl items-center gap-8 lg:grid-cols-2 lg:gap-12" data-id="element-140" data-mp="1t6qnhbfgbary">
          <img src={productImages.offer} alt={productImages.offerAlt} loading="lazy" className="mx-auto h-auto w-full max-w-md drop-shadow-[0_24px_40px_rgba(0,0,0,0.5)] lg:max-w-none" data-id="element-141" data-mp="26xls2bix35pq" />

          <div className="rounded-3xl border border-gold-soft/45 bg-night-panel p-6 sm:p-8" data-id="element-142" data-mp="19hgaw6b055y2">
            <ul className="space-y-3.5" data-id="element-143" data-mp="14pd6bubwqcuy">
              {offerItems.map(item => <li key={item} className="flex gap-3" data-id="element-144" data-mp="19o6hvh7mvtsh">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-gold-soft/15" data-id="element-145" data-mp="19mlmjpdhw6tk">
                    <CheckIcon className="h-3.5 w-3.5 text-gold-soft" aria-hidden="true" data-id="element-146" data-mp="1egzknzjjks1x" />
                  </span>
                  <span className="font-sans text-base font-medium leading-snug text-parchment" data-id="element-147" data-mp="lq7kkqzcvj9b">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-7 border-t border-night-line pt-7 text-center" data-id="element-148" data-mp="vof0d6hwrv9q">
              <p className="font-sans text-base text-parchment/60" data-id="element-149" data-mp="vqhuo2q3gak9">
                Valor total: <span className="line-through" data-id="element-150" data-mp="zrbkj1n3jzfs">{launchOffer.regularPrice}</span>
              </p>
              <p className="mt-1 font-display text-5xl font-semibold text-gold-soft sm:text-6xl" data-id="element-151" data-mp="273amfdivwz0b">
                <span className="mr-2 align-middle font-sans text-lg font-semibold tracking-[0.12em] text-parchment sm:text-xl" data-id="element-152" data-mp="2b3cdksqzua1c">
                  HOY:
                </span>
                {launchOffer.price}
              </p>
              <p className="mt-2 font-sans text-sm font-medium text-parchment/75" data-id="element-153" data-mp="73nl5sukti16">
                {launchOffer.paymentNote}
              </p>

              <div className="mt-7" data-id="element-154" data-mp="g329aln9tgii">
                <CtaButton size="block" href={checkoutUrl} data-id="element-155" data-mp="fzwhgyn9c0j3">
                  {cta.label}
                </CtaButton>
                <p className="mt-3 font-sans text-xs leading-relaxed text-parchment/55 sm:text-[0.8rem]" data-id="element-156" data-mp="3kg7f0n9bvazy">
                  {cta.offerMicro}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}